import { useStore } from 'vuex';

export function useAnalytics() {
  const store = useStore();

  /**
   * Convenience function to dispatch generic/trackEvent actions.
   *
   * @param {string} category e.g. "movie"
   * @param {string} action e.g. "rate"
   * @param {array|string|null|boolean|object} name e.g. "Iron Man"
   * @param {string|number|null} value 10
   */
  function trackEvent(category, action, name = null, value = null) {
    store.dispatch('generic/trackEvent', {
      category, action, name, value
    });
  }

  return {
    trackEvent,
  };
}
